import { render, staticRenderFns } from "./Courses-list-tab.vue?vue&type=template&id=5c344e3c"
import script from "./Courses-list-tab.vue?vue&type=script&lang=js"
export * from "./Courses-list-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports